import React, { useState, useEffect } from 'react';
import { Redirect, RouteComponentProps } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession, login } from 'app/shared/reducers/authentication';
import LoginModal from './login-modal';
import { Storage } from 'react-jhipster';

export const Login = (props: RouteComponentProps<any>) => {
  const AUTH_TOKEN_KEY = 'app-authenticationToken';

  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loginError = useAppSelector(state => state.authentication.loginError);
  const showModalLogin = useAppSelector(state => state.authentication.showModalLogin);
  const [showModal, setShowModal] = useState(showModalLogin);
  const { location } = props;

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const token = searchParams.get('token');
  
    if (token) {
      try {
        const decodedToken = atob(token);
        Storage.session.set(AUTH_TOKEN_KEY, decodedToken);
        dispatch(getSession());
      } catch (error) {
        console.error('Error decoding token:', error);
        return;
      }
  
      props.history.replace('/');
    }
  }, []);

  useEffect(() => {
    setShowModal(true);
  }, []);

  const handleLogin = (username, password, rememberMe = false) => dispatch(login(username, password, rememberMe));

  const handleClose = () => {
    setShowModal(false);
    props.history.push('/');
  };

  const { from } = (location.state as any) || { from: { pathname: '/', search: location.search } };
  if (isAuthenticated) {
    return <Redirect to={from} />;
  }
  return <LoginModal showModal={showModal} handleLogin={handleLogin} handleClose={handleClose} loginError={loginError} />;
};

export default Login;
